<script lang="ts">
  import { useNavigate } from 'svelte-navigator';

  import { Container } from '../services/container';
  import { Backend } from '../services/backend';
  import { Auth } from '../services/auth';

  import { AppState } from '../etc/stores';

  import LoadingPage from '../components/templates/LoadingPage.svelte';

  const auth = Container.get(Auth);
  const backend = Container.get(Backend);

  const customerImportCampaignIsValid =
    $AppState.customerImportCampaign?.id &&
    $AppState.customerImportCampaign?.status === 'active';

  const navigate = useNavigate();

  async function claimCoins() {
    const redeemPayload = {
      providerName: auth.provider,
      campaignId: $AppState.customerImportCampaign.id
    };

    const customerImportRedeemResponse = await backend.customerImportRedeem(
      redeemPayload
    );

    navigate('/customer-import-redeem-status', {
      state: {
        ...customerImportRedeemResponse,
        coins: Number($AppState.customerImportCampaign.coinsReward).toFixed(0)
      }
    });
  }

  async function handleFlow() {
    if ($AppState.auth.connected && customerImportCampaignIsValid) {
      claimCoins();

      return;
    }

    if (customerImportCampaignIsValid) {
      navigate('/customer-import-welcome', {
        state: {
          coins: Number($AppState.customerImportCampaign.coinsReward).toFixed(0)
        }
      });

      return;
    }

    navigate('/');
  }
</script>

<LoadingPage on:complete={handleFlow} showFooterNextPage={true} />

<style lang="scss">
</style>
